
import type { PropType } from 'vue'
import type { AuditItem } from '../../models/services/audit'
import type { AuditObjectTypeConfigProvider } from '../../providers/interfaces/audit-object-type-config.provider'
import { defineComponent } from 'vue'
import { CONTAINER } from '../../config/inversify.config'
import { TYPES } from '../../config/inversify.types'
import { ColorEnum } from '../../enums'

export default defineComponent({
  name: 'AuditDescription',
  props: {
    audit: {
      type: Object as PropType<AuditItem>,
      required: true,
    },
    messages: {
      type: Object,
      required: true,
    },
    size: {
      type: String, // 'normal' | 'small'
      default: 'normal',
    },
  },
  data(): Record<string, any> {
    return {
      baseClass: 'epb-audit-description',
      ColorEnum,
    }
  },
  computed: {
    objectTypeColor(): ColorEnum {
      const provider = CONTAINER.get<AuditObjectTypeConfigProvider>(
        TYPES.AuditObjectTypeConfigProvider,
      )
      return provider(this.audit.payload.objectType as string).color
    },
    objectTypeText(): string {
      const provider = CONTAINER.get<AuditObjectTypeConfigProvider>(
        TYPES.AuditObjectTypeConfigProvider,
      )
      return provider(this.audit.payload.objectType as string).featureName
    },
  },
})
